export default __webpack_public_path__ + "static/media/board2.d0b47797.jpg";